<template>
  <v-dialog v-model="dialog" max-width="600px" persistent scrollable>
    <v-card style="border-radius: 10px">
      <v-toolbar
        dark
        style="background-color: #fddf00; color: black"
        class="elevation-0"
      >
        <v-toolbar-title>
          <h4>{{ "Create Hotel" }}</h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog" color="black" size="30">close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto" class="px-4 pt-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="hotel.name"
            label="Hotel Name"
            :rules="[(v) => !!v || 'Hotel Name is required']"
            required
          ></v-text-field>
          <v-textarea
            v-model="hotel.description"
            label="Description"
            :rules="[(v) => !!v || 'Description is required']"
            required
          ></v-textarea>
          <v-text-field
            v-model="hotel.star_rating"
            label="Star Rating"
            :rules="[(v) => !!v || 'Star Rating is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="hotel.contact_email"
            label="Contact Email"
            :rules="[
              (v) => !!v || 'Contact Email is required',
              (v) => /.+@.+\..+/.test(v) || 'Email must be valid',
            ]"
            required
          ></v-text-field>
          <v-text-field
            v-model="hotel.contact_phone"
            label="Contact Phone"
            :rules="[(v) => !!v || 'Contact Phone is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="hotel.website"
            label="Website"
            :rules="[(v) => !!v || 'Website is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="hotel.locations[0].name"
            label="Location"
            :rules="[(v) => !!v || 'Location is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="hotel.locations[0].latitude"
            label="Latitude"
            :rules="[(v) => !!v || 'Latitude is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="hotel.locations[0].longitude"
            label="Longitude"
            :rules="[(v) => !!v || 'Longitude is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="hotel.locations[0].province"
            label="Province"
            :rules="[(v) => !!v || 'Province is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="hotel.app_style.primary_color"
            label="Primary Color"
            :rules="[(v) => !!v || 'Primary Color is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="hotel.app_style.secondary_color"
            label="Secondary Color"
            :rules="[(v) => !!v || 'Secondary Color is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="hotel.app_style.hotel_logo"
            label="Hotel Logo URL"
            :rules="[(v) => !!v || 'Hotel Logo URL is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="hotel.app_style.hotel_service_domain"
            label="Hotel Service Domain"
            :rules="[(v) => !!v || 'Hotel Service Domain is required']"
            required
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions style="padding-bottom: 30px" class="pr-4">
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          style="
            width: 120px;
            background: #000000 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 7px;
            font-weight: bold;
            letter-spacing: 0.1rem;
            color: white;
          "
          @click="closeDialog"
        >
          Cancel
        </v-btn>
        <v-btn
          color="success"
          style="
            width: 120px;
            background: #000000 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 7px;
            font-weight: bold;
            letter-spacing: 0.1rem;
            color: white;
          "
          @click="saveHotel"
          :loading="saving"
        >
          {{ "Save" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    hotelData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      hotel: {
        name: "",
        description: "",
        star_rating: null,
        contact_email: "",
        contact_phone: "",
        website: "",
        locations: [
          {
            name: "",
            latitude: "",
            longitude: "",
            province: "",
          },
        ],
        app_style: {
          primary_color: "",
          secondary_color: "",
          hotel_logo: "",
          hotel_service_domain: "",
        },
      },
      saving: false,
    };
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.resetForm();
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close", false);
      this.resetForm();
    },
    saveHotel() {
      if (this.$refs.form.validate()) {
        let hotelClone = JSON.parse(JSON.stringify(this.hotel));
        this.saving = true;
        let _this = this;
        this.$emit("save", {
          data: hotelClone,
          done() {
            _this.saving = false;
            _this.resetForm();
          },
          failed() {
            _this.saving = false;
          },
        });
      }
    },
    resetForm() {
      this.hotel = {
        name: "",
        description: "",
        star_rating: null,
        contact_email: "",
        contact_phone: "",
        website: "",
        locations: [
          {
            name: "",
            latitude: "",
            longitude: "",
            province: "",
          },
        ],
        app_style: {
          primary_color: "",
          secondary_color: "",
          hotel_logo: "",
          hotel_service_domain: "",
        },
      };
    },
  },
};
</script>

<style>
.line-newpass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-newpass:after {
  content: "Set Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>
